import {
  MutationCreateNewDesignerAccountArgs,
  MutationCreateNewHomeownerAccountArgs,
  MutationUpdateDesignerAccountArgs,
  MutationUpdateHomeownerAccountArgs,
  DesignerUser,
  HomeOwnerUser,
  MutationLoginUserArgs,
} from "../../__generated__/types";

export type AccountCreationResult = {
  success: boolean;
  data?: string;
  error?: string;
};

export type MembershipStatusSnapshot = {
  subscription?: string | null;
  paymentStatus?: string | null;
  billingCycle?: string | null;
  autoRenew?: boolean | null;
  nextRenewalDate?: string | null;
  subscriptionStartDate?: string | null;
  subscriptionEndDate?: string | null;
  monthlyPlatformFeeNextBillingDate?: string | null;
  currentPlanTier?: string | null;
};

export type UserContextDispatchType = {
  createNewDesignerAccount: (
    args: MutationCreateNewDesignerAccountArgs
  ) => Promise<AccountCreationResult>;
  createNewHomeownerAccount: (
    args: MutationCreateNewHomeownerAccountArgs
  ) => Promise<AccountCreationResult>;
  updateDesignerAccountData: (
    args: MutationUpdateDesignerAccountArgs
  ) => Promise<DesignerUser | undefined>;
  updateHomeownerAccountData: (
    args: MutationUpdateHomeownerAccountArgs
  ) => Promise<HomeOwnerUser | undefined>;
  loginUserAccount: (
    args: MutationLoginUserArgs
  ) => Promise<{ error: unknown } | undefined>;
  logoutUserAccount: () => void;
  confirmUserEmail: (token: string, email?: string) => Promise<string | { error: string }>;
  resetUserPassword: (
    email: string,
    password: string
  ) => Promise<boolean | { error: string }>;
  syncMembershipStatus: (snapshot?: MembershipStatusSnapshot | null) => void;
};

export enum UserContextActions {
  SET_USER = "SET_USER",
  SET_TOKEN = "SET_TOKEN",
}
